import React from "react";
import { useSelector } from "react-redux";
import { DataTable } from "CommonComponent";
import { Columns } from "./component";

const QueueTab = () => {
  const { data, loading } = useSelector(
    (state) => state.acdReportState.queueReport
  );

  return (
    <div>
      <DataTable
        columns={Columns}
        data={data}
        serverSide={false}
        showSearch={false}
        loading={loading}
        className="table-container"
      />
    </div>
  );
};

export default QueueTab;
